import React, { useState } from 'react';
import { Send, CheckCircle } from 'lucide-react';

const ContactForm = ({ lang }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const content = {
    en: {
      title: 'Get in Touch',
      subtitle: 'Have a question or want to collaborate? Send us a message.',
      namePlaceholder: 'Your Name',
      emailPlaceholder: 'your@email.com',
      messagePlaceholder: 'Your message...',
      submit: 'Send Message',
      submitted: 'Message Sent!',
      submittedSub: 'We\'ll get back to you soon.'
    },
    es: {
      title: 'Contáctanos',
      subtitle: '¿Tienes una pregunta o quieres colaborar? Envíanos un mensaje.',
      namePlaceholder: 'Tu Nombre',
      emailPlaceholder: 'tu@email.com',
      messagePlaceholder: 'Tu mensaje...',
      submit: 'Enviar Mensaje',
      submitted: '¡Mensaje Enviado!',
      submittedSub: 'Te responderemos pronto.'
    }
  };

  const t = content[lang] || content.en;

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  if (submitted) {
    return (
      <div className="text-center py-8">
        <CheckCircle className="w-12 h-12 text-[#00FFD1] mx-auto mb-4" />
        <h3 className="text-xl font-semibold text-white mb-2">{t.submitted}</h3>
        <p className="text-white/60">{t.submittedSub}</p>
      </div>
    );
  }

  return (
    <div className="w-full max-w-md">
      <h3 className="text-xl font-semibold text-white mb-2">{t.title}</h3>
      <p className="text-white/50 text-sm mb-6">{t.subtitle}</p>
      
      <form 
        name="contact" 
        method="POST" 
        data-netlify="true"
        netlify-honeypot="bot-field"
        onSubmit={handleSubmit}
        className="space-y-4"
      >
        <input type="hidden" name="form-name" value="contact" />
        <input type="hidden" name="bot-field" />
        
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder={t.namePlaceholder}
          required
          className="w-full bg-black/50 border border-white/20 px-4 py-3 text-white placeholder-white/30 focus:border-[#00FFD1] focus:outline-none transition-colors"
        />
        
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder={t.emailPlaceholder}
          required
          className="w-full bg-black/50 border border-white/20 px-4 py-3 text-white placeholder-white/30 focus:border-[#00FFD1] focus:outline-none transition-colors"
        />
        
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          placeholder={t.messagePlaceholder}
          required
          rows={4}
          className="w-full bg-black/50 border border-white/20 px-4 py-3 text-white placeholder-white/30 focus:border-[#00FFD1] focus:outline-none transition-colors resize-none"
        />
        
        <button
          type="submit"
          className="w-full bg-[#00FFD1] text-black py-3 font-medium hover:bg-[#00FFD1]/90 transition-colors flex items-center justify-center gap-2 group"
        >
          {t.submit}
          <Send className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
